// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8"><path d="M7.71 6.29L5.41 4l2.3-2.29A1 1 0 006.29.29L4 2.59 1.71.29A1 1 0 10.29 1.71L2.59 4 .29 6.29a1 1 0 101.42 1.42L4 5.41l2.29 2.3a1 1 0 001.42-1.42z"/></svg>
);

export default fn;
